exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid[data-v-42f315fe] {\n  height: 100%;\n  width: 100%;\n}\n.c-grid .define[data-v-42f315fe] {\n  display: none !important;\n  position: fixed;\n  top: -300px;\n  left: -300px;\n}\n", ""]);

// exports
